import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../../../services/userService/user.service";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from "@angular/common";
import * as moment from "moment";

@Component({
  selector: "app-addcontact",
  templateUrl: "./addcontact.component.html",
  styleUrls: ["./addcontact.component.css"],
})
export class AddcontactComponent implements OnInit {
  permission: any;
  disableDate() {
    return false;
  }
  minDate = new Date();
  registerForm: FormGroup;
  submitted = false;
  countryListArray: any = [];
  CountryList: any = [];
  ownerList: any = [];
  dropdownCountry: any = {};
  dropdownState: any = {};
  selectedState: any = [];
  dropdownCity;
  any = {};
  designationArray: any = [];
  dropdownDesignation: any = {};
  cityArray: any = [];
  cityList: any = [];
  selectedCity: any[];
  dropdownNationality: any = [];
  dropdownLanguage: any = {};
  dropdowncompany: any = {};
  dropdownReligion: any = {};
  dropdownProReservation: any = {};
  languageArray: any = [];
  companyArray: any = [];
  religionArray: any = [];
  proreservationArray: any = [];
  endDate: any = "";
  date: any;
  end: any = "";
  showaccount: any;
  userid: any;
  dropdownower: any = {};

  constructor(
    private formBuilder: FormBuilder,
    private UserService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private datePipe: DatePipe
  ) {
    this.minDate.setDate(this.minDate.getDate());
  }

  //whatsappPattern = "^((\\+91-?)|0)?[0-9]{6,15}$";
  emailPattern = new RegExp(/^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/);
  contactPattern = "^[a-zA-Z0-9 ]+$";

  ngOnInit(): void {
    let userid = localStorage.getItem("userId");
    this.userid = this.UserService.decryptData(userid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    if (this.permission.Contact_Add != 1 && this.userid != 1) {
      this.toastr.error("You do not have permission");
      this.router.navigate(["/profile"]);
    }

    this.registerForm = this.formBuilder.group({
      ContactName: [
        "",
        [Validators.required, Validators.pattern(this.contactPattern)],
      ],
      Mobile: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(/^\+\d{6,15}$/),
        ],
      ],
      Email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      Country: ["", Validators.required],
      State: ["", Validators.required],
      City: ["", Validators.required],
      Designation: ["", Validators.required],
      Company: ["", Validators.required],
      ContactOwner: ["", Validators.required],
      Gender: ["", Validators.required],
      Nationality: ["", Validators.required],
      Language: [""],
      Religion: [""],
      ProReservation: [""],
      Landline: [
        "",
        [Validators.minLength(6), Validators.pattern(/^\+\d{6,15}$/)],
      ],
      WhatsappNumber: [
        "",
        [Validators.minLength(6), Validators.pattern(/^\+\d{6,15}$/)],
      ],
      DateOfBirth: [""],
      Address1: [""],
      Address2: [""],
      IsVVIP: [false],
      IsFactoryVisit: [false],
      FactoryVisitComments: [""],
      Comments: [""],
    });

    this.dropdownCountry = {
      singleSelection: true,
      text: "Select Country",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownState = {
      singleSelection: true,
      text: "Select State",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownCity = {
      singleSelection: true,
      text: "Select City",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownNationality = {
      singleSelection: true,
      text: "Select Nationality",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownLanguage = {
      singleSelection: true,
      text: "Select Language",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdowncompany = {
      singleSelection: true,
      text: "Select company",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownReligion = {
      singleSelection: true,
      text: "Select Religion",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownProReservation = {
      singleSelection: true,
      text: "Select ProReservation",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownDesignation = {
      singleSelection: true,
      text: "Select Designation",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownower = {
      singleSelection: true,
      text: "Select Owner",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };

    this.getproreservation();
    this.getcompany();
    this.getlanguage();
    this.getreligion();
    this.getDesignation();
    this.getCountries();
    this.getowner();
  }

  get f() {
    return this.registerForm.controls;
  }

  getowner() {
    this.UserService.GetAllUser({ userid: this.userid }).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.showaccount = response;
          for (const accountData of this.showaccount["Data"]) {
            this.ownerList.push({
              id: accountData["UserId"],
              itemName: `${accountData["UserName"]}(${accountData["EmailId"]})${accountData["EmployeeId"]}`,
            });
          }
        } else {
          this.showaccount = [];
        }
      }
    );
  }
  selectedownerName: string = "";
  selectedownerId: string = "";
  selectedowner: any = [];
  onwnerSelect(item: any) {
    this.selectedownerName = "";
    this.selectedownerId = "";
    this.selectedowner.forEach((element) => {
      this.selectedownerName += element["itemName"];
      this.selectedownerId += element["id"];
    });
  }

  getCountries() {
    let data = {};
    this.UserService.GetCountries(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.countryListArray = res;
        for (const countryData of this.countryListArray["Data"]) {
          this.CountryList.push({
            id: countryData["Id"],
            itemName: countryData["Name"],
          });
        }
      } else {
        this.countryListArray = [];
      }
    });
  }

  designationList: any = [];
  getDesignation() {
    let data = {};
    this.UserService.GetDesignation(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.designationArray = res["Data"];
        if (this.designationArray.length > 0) {
          for (const designationData of this.designationArray) {
            this.designationList.push({
              id: designationData["DesignationID"],
              itemName: designationData["Designation"],
            });
          }
        }
      } else {
        this.designationArray = [];
      }
    });
  }

  languageList: any = [];
  getlanguage() {
    let data = {};
    this.UserService.GetLanguage(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.languageArray = res["Data"];
        if (this.languageArray.length > 0) {
          for (const languageData of this.languageArray) {
            this.languageList.push({
              id: languageData["LanguageId"],
              itemName: languageData["Name"],
            });
          }
        }
      } else {
        this.languageArray = [];
      }
    });
  }

  companyList: any = [];
  getcompany() {
    let data = {};
    this.UserService.GetAllCompanyName(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.companyArray = res["Data"];
        if (this.companyArray.length > 0) {
          for (const companyData of this.companyArray) {
            this.companyList.push({
              id: companyData["CompanyId"],
              itemName: companyData["CompanyName"],
            });
          }
        }
      } else {
        this.companyArray = [];
      }
    });
  }

  religionList: any = [];
  getreligion() {
    let data = {};
    this.UserService.GetReligion(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.religionArray = res["Data"];
        if (this.religionArray.length > 0) {
          for (const religionData of this.religionArray) {
            this.religionList.push({
              id: religionData["ReligionId"],
              itemName: religionData["Name"],
            });
          }
        }
      } else {
        this.religionArray = [];
      }
    });
  }

  proreservationList: any = [];
  getproreservation() {
    let data = {};
    this.UserService.GetProReservation(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.proreservationArray = res["Data"];
        if (this.proreservationArray.length > 0) {
          for (const proreservationData of this.proreservationArray) {
            this.proreservationList.push({
              id: proreservationData["ProReservationId"],
              itemName: proreservationData["Name"],
            });
          }
        }
      } else {
        this.proreservationArray = [];
      }
    });
  }

  selectedCountryName: string = "";
  selectedCountryId: string = "";
  selectedCountry: any = [];
  onCountrySelect(item: any) {
    this.selectedCountryName = "";
    this.selectedCountryId = "";
    this.selectedCountry.forEach((element) => {
      this.selectedCountryName += element["itemName"];
      this.selectedCountryId += element["id"];
    });
    this.stateList = [];
    this.selectedState = [];
    this.cityList = [];
    this.selectedCity = [];
    this.getStatesByCountryId(this.selectedCountryId);
  }
  stateArray: any = [];
  stateList: any = [];
  getStatesByCountryId(id) {
    let data = {
      CountryId: id,
    };
    this.UserService.GetStatesByCountryId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.stateArray = res;
        for (const stateData of this.stateArray["Data"]) {
          this.stateList.push({
            id: stateData["Id"],
            itemName: stateData["Name"],
          });
        }
      } else {
        this.stateList = [];
      }
    });
  }
  selectedStateName: string = "";
  selectedStateId: string = "";
  onStateSelect(item: any) {
    this.selectedStateName = "";
    this.selectedStateId = "";
    this.selectedState.forEach((element) => {
      this.selectedStateName += element["itemName"];
      this.selectedStateId += element["id"];
    });
    this.cityList = [];
    this.selectedCity = [];
    this.getCitiesByStateId(this.selectedStateId);
  }
  getCitiesByStateId(id) {
    let data = {
      StateId: id,
    };
    this.UserService.GetCitiesByStateId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.cityArray = res;
        for (const cityData of this.cityArray["Data"]) {
          this.cityList.push({
            id: cityData["Id"],
            itemName: cityData["Name"],
          });
        }
      } else {
        this.cityList = [];
      }
    });
  }
  selectedCityName: string = "";
  selectedCityId: string = "";
  onCitySelect(item: any) {
    this.selectedCityName = "";
    this.selectedCityId = "";
    this.selectedCity.forEach((element) => {
      this.selectedCityName += element["itemName"];
      this.selectedCityId += element["id"];
    });
  }
  selectedLanguage: any = [];
  selectedLanguageName: string = "";
  selectedLanguageId: string = "";
  onLanguageSelect(item: any) {
    this.selectedLanguageName = "";
    this.selectedLanguageId = "";
    this.selectedLanguage.forEach((element) => {
      this.selectedLanguageName += element["itemName"];
      this.selectedLanguageId += element["id"];
    });
  }
  selectedcompany: any = [];
  selectedcompanyName: string = "";
  selectedcompanyId: string = "";
  oncompanySelect(item: any) {
    this.selectedcompanyName = "";
    this.selectedcompanyId = "";
    this.selectedcompany.forEach((element) => {
      this.selectedcompanyName += element["itemName"];
      this.selectedcompanyId += element["id"];
    });
  }
  selectedReligion: any = [];
  selectedReligionName: string = "";
  selectedReligionId: string = "";
  onReligionSelect(item: any) {
    this.selectedReligionName = "";
    this.selectedReligionId = "";
    this.selectedReligion.forEach((element) => {
      this.selectedReligionName += element["itemName"];
      this.selectedReligionId += element["id"];
    });
  }
  selectedProReservation: any = [];
  selectedProReservationName: string = "";
  selectedProReservationId: string = "";
  onProReservationSelect(item: any) {
    this.selectedProReservationName = "";
    this.selectedProReservationId = "";
    this.selectedProReservation.forEach((element) => {
      this.selectedProReservationName += element["itemName"];
      this.selectedProReservationId += element["id"];
    });
  }
  selectedNationality: any = [];
  selectedNationalityName: string = "";
  selectedNationalityId: string = "";
  onNationalitySelect(item: any) {
    this.selectedNationalityName = "";
    this.selectedNationalityId = "";
    this.selectedNationality.forEach((element) => {
      this.selectedNationalityName += element["itemName"];
      this.selectedNationalityId += element["id"];
    });
  }
  selectedDesignation: any = [];
  selectedDesignationName: string = "";
  selectedDesignationId: string = "";
  onDesignationSelect(item: any) {
    this.selectedDesignationName = "";
    this.selectedDesignationId = "";
    this.selectedDesignation.forEach((element) => {
      this.selectedDesignationName += element["itemName"];
      this.selectedDesignationId += element["id"];
    });
  }

  onSubmit() {
    this.spinner.show();
    this.submitted = true;
    if (this.registerForm.valid) {
      if (this.selectedReligionId == "") {
        this.selectedReligionId = "0";
      }
      if (this.selectedLanguageId == "") {
        this.selectedLanguageId = "0";
      }
      if (this.selectedProReservationId == "") {
        this.selectedProReservationId = "0";
      }
      if (this.selectedStateId == "") {
        this.selectedStateId = "0";
        this.selectedCityId = "0";
      }
      if (this.selectedCityId == "") {
        this.selectedCityId = "0";
      }
      if (
        this.registerForm.value.DateOfBirth &&
        this.registerForm.value.DateOfBirth != ""
      ) {
        this.endDate = moment(
          this.registerForm.value.DateOfBirth,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");
        this.date = new Date(this.minDate);
        let year = this.date.getFullYear();
        this.end = this.datePipe.transform(this.endDate, "yyyy-MM-dd");

        let result = this.end.substr(0, 4);
        let diff = year - result;
        if (diff < 10) {
          this.toastr.error("Age Should be More Then 10 Years");
          return;
        }
      }
      let data = {
        ContactName: this.registerForm.value.ContactName,
        Mobile: this.registerForm.value.Mobile,
        Landline: this.registerForm.value.Landline,
        WhatsappNumber: this.registerForm.value.WhatsappNumber,
        Email: this.registerForm.value.Email,
        Country: this.selectedCountryId,
        State: this.selectedStateId,
        City: this.selectedCityId,
        DateOfBirth: this.endDate,
        Address1: this.registerForm.value.Address1,
        Address2: this.registerForm.value.Address2,
        Company: this.selectedcompanyId,
        Designation: this.selectedDesignationId,
        ContactOwner: this.selectedownerId,
        Nationality: this.selectedNationalityId,
        Religion: this.selectedReligionId,
        Language: this.selectedLanguageId,
        ProReservation: this.selectedProReservationId,
        Gender: this.registerForm.value.Gender,
        IsVVIP: this.registerForm.value.IsVVIP,
        IsFactoryVisit: this.registerForm.value.IsFactoryVisit,
        FactoryVisitComments: this.registerForm.value.FactoryVisitComments,
        Comments: this.registerForm.value.Comments,
      };
      this.UserService.AddUpdateContact(data).subscribe((res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.toastr.success(res["Msg"]);
          this.ngOnInit();
          this.router.navigate(["/contacts/contacts-list"]);
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Message"]);
          this.spinner.hide();
        }
        this.submitted = false;
      });
    }
  }

  //space not allowed
  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }
}
